import React, { FC } from 'react';
import styles from './search_error_message.module.scss';

type Props = {
  error: string;
};

export const SearchErrorMessage: FC<Props> = ({ error }) => (
  <div className={styles.errorContainer}>
    <div className={styles.error} dangerouslySetInnerHTML={{ __html: error }} />
  </div>
);
